export enum GreenRoomEnum {
    Unseen = 1,
    Visible = 2,
    Hidden = 3,
}
